__turbopack_context__.v({
  "className": "jetbrains_mono_55d3a55e-module__L_C_3q__className",
  "variable": "jetbrains_mono_55d3a55e-module__L_C_3q__variable",
});
